















































import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'inversify-props';
import PercentFilter from '@/modules/common/filters/percent.filter';
import PriceFilter from '@/modules/common/filters/price.filter';
import Calendar from '@/modules/common/components/ui-kit/calendar.vue';
import RatesCalendarItem from '@/modules/rates/components/calendar/rates-calendar-item.vue';
import RatesCalendarItemFilterAll from '@/modules/rates/components/calendar/rates-calendar-item-filter-all.vue';
import DocumentFiltersService, { DocumentFiltersServiceS } from '@/modules/document-filters/document-filters.service';
import RatesService, { RatesServiceS } from '@/modules/rates/rates.service';
import CalendarItemNoData from '@/modules/common/components/calendar-item-no-data.vue';
import CalendarItemNoAvailability from '@/modules/common/components/calendar-item-no-availability.vue';
import CalendarItemEmpty from '@/modules/common/components/calendar-item-empty.vue';
import RatesFiltersService, { RatesFiltersServiceS } from '@/modules/rates/rates-filters.service';
import setScrollbarPadding from '@/modules/common/filters/scrollbar-padding.filter';
import Day from '@/modules/common/types/day.type';
import DayRateTooltip from './day-rate-tooltip.vue';

let timeout: ReturnType<typeof setTimeout>;

@Component({
    filters: { PercentFilter, PriceFilter },
    components: {
        Calendar,
        RatesCalendarItem,
        CalendarItemNoData,
        CalendarItemEmpty,
        CalendarItemNoAvailability,
        RatesCalendarItemFilterAll,
        DayRateTooltip,
    },
})
export default class RatesCalendar extends Vue {
    @Inject(DocumentFiltersServiceS) documentFiltersService!: DocumentFiltersService;
    @Inject(RatesServiceS) ratesService!: RatesService;
    @Inject(RatesFiltersServiceS) private ratesFiltersService!: RatesFiltersService;

    tooltipFocusElement: HTMLElement | null = null;
    tooltipDay: Day | null = null;

    get year() {
        this.ratesService.storeState.loading.isLoading();
        return this.documentFiltersService.storeState.settings.year;
    }

    get month() {
        return this.documentFiltersService.storeState.settings.month;
    }

    get filterAll() {
        return this.ratesFiltersService.isProviderAll;
    }

    updated() {
        setScrollbarPadding();
    }

    setTooltipFocus(e: MouseEvent) {
        if (!e.currentTarget) return;

        this.tooltipFocusElement = e.currentTarget as unknown as HTMLElement;
        this.tooltipDay = +(this.tooltipFocusElement.dataset.day || 1) as Day;

        clearTimeout(timeout);
    }

    clearTooltipFocus() {
        timeout = setTimeout(() => {
            this.tooltipDay = null;
        }, 100);
    }
}
